import * as tealiumTrackingFunctions from './homepageTealium';

const combindedTrackingFunctions = tealiumTrackingFunctions;

export default combindedTrackingFunctions;
